import querystring from 'query-string';

export const dispatchUserChangeEvent = (uberToken, lastItemAdded) => {
    window?.SF?.notifyUserChange?.({ uberToken, lastItemAdded });
};

export const redirectToUrl = (redirect, location, locale) => {
    if (redirect !== false) {
        const { search = '' } = location;
        const { redirect: queryRedirect } = querystring.parse(search.substring(1));
        // Prevent javascript: and data: query injections
        const sanitisedQueryRedirect = queryRedirect?.replace(':', '%3A');
        const absolutePath = new RegExp('.*(www\.|\/\/)+.*');
        const accountPath = `/${locale.id}/account`;

        let redirectPath;

        if (sanitisedQueryRedirect) {
            redirectPath = absolutePath.test(sanitisedQueryRedirect) ? accountPath : sanitisedQueryRedirect;
        } else if (redirect && typeof redirect === 'string') {
            redirectPath = redirect;
        } else {
            redirectPath = accountPath;
        }

        window.location.assign(redirectPath);
    }
};
